"use client";
import { CommandPaletteProps } from "./types";
import { useCommandPaletteSearch } from "./useCommandPaletteSearch";
import { useCommandPaletteNavigation } from "./useCommandPaletteNavigation";
import { CommandPaletteInput } from "./components/CommandPaletteInput";
import { CommandPaletteResultsList } from "./components/CommandPaletteResultsList";
import { CommandPaletteFooter } from "./components/CommandPaletteFooter";
import { useEffect } from "react";
import { Backdrop } from "@/components/ui/Backdrop";

export default function CommandPalette(props: CommandPaletteProps) {
  const {
    submittedQuery,
    results,
    flatResults,
    handleSelect,
    handleSearchSubmit,
    handleClear,
    isFetching,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useCommandPaletteSearch(props);

  useEffect(() => {
    if (!props.isOpen) {
      handleClear();
    }
  }, [handleClear, props.isOpen]);

  const { listRef, inputRef } = useCommandPaletteNavigation({
    isOpen: props.isOpen,
    submittedQuery,
    flatResults,
    onSelect: handleSelect,
  });

  if (!props.isOpen) return null;

  return (
    <div
      className="animate-cmd-fade-in fixed inset-0 z-50 flex items-start justify-center pt-[10vh]"
      onClick={props.onClose}
    >
      <Backdrop />

      <div
        className="animate-cmd-scale-in relative mx-4 flex w-full max-w-[540px] flex-col overflow-hidden rounded-xl bg-white shadow-[0_8px_40px_rgba(0,0,0,0.12),0_0_0_1px_rgba(0,0,0,0.04)]"
        onClick={(e) => e.stopPropagation()}
      >
        <CommandPaletteInput
          inputRef={inputRef}
          onClear={handleClear}
          onSearch={handleSearchSubmit}
        />
        <CommandPaletteResultsList
          listRef={listRef}
          results={results}
          flatResults={flatResults}
          onSelect={handleSelect}
          submittedQuery={submittedQuery}
          isFetching={isFetching}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
        />
        <CommandPaletteFooter />
      </div>
    </div>
  );
}
